import axios from "axios";
import AppConstants from "../../AppConstrains/AppConstrains";
const baseURL = AppConstants.baseURL;
// const baseURL = "http://localhost:5800";

export default axios.create({
  baseURL: baseURL,
});
export const axiosPrivate = axios.create({
  baseURL: baseURL,
  withCredentials: true,
});
